class BrowserCompatibility {
  isCompatible (ua) {
    const isIE = /\sMSIE\s/g
    return ua.match(isIE) === null
  }

  static isMobile (ua) {
    return !!ua.match(/^(?=.*\bMobile\b).*$/i)
  }

  static isIOS (ua) {
    return !!ua.match(/(iPhone|iPad)/i)
  }

  static isAndroid (ua) {
    return !!ua.match(/^(?=.*\bAndroid\b).*$/i)
  }

  static isTouchEnabled () {
    return ('ontouchstart' in window) ||
             (navigator.maxTouchPoints > 0) ||
             (navigator.maxTouchPoints > 0)
  }
}

export default BrowserCompatibility
